import React from 'react';
import pt from 'prop-types';

import MenuForm from 'components/storefront/menu-form';

export default class NewMenuModalPage extends React.Component {
  static contextTypes = {
    openModal: pt.func.isRequired,
    closeModal: pt.func.isRequired,
  };

  static propTypes = {
    edited: pt.bool,
  };

  menuFormRef = null;

  onClickSubmit = (event) => {
    event.preventDefault();
    this.menuFormRef?.submit();
  };

  onCloseModal = (event) => {
    if (this.props.edited) {
      event.preventDefault();
      this.context.openModal('ConfirmRouteLeave', {
        onConfirm: () => {
          this.context.closeModal();
        },
      });
    }
  };

  getRef = (ref) => {
    this.menuFormRef = ref;
  };

  render() {
    return (
      <MenuForm
        {...this.props}
        modalProps={{
          title: 'New menu',
          width: 800,
          localized: true,
          onClose: this.onCloseModal,
          actions: [{ label: 'Save menu', onClick: this.onClickSubmit }],
        }}
        onRef={this.getRef}
      />
    );
  }
}
